export default function(x, y) {
  return 'translate(' + x + ',' + y + ')';
}


// WEBPACK FOOTER //
// ./~/vega-scenegraph/src/util/svg/translate.js